export default "__VITE_ASSET__CLt7ZnQt__"